module.exports = __webpack_public_path__ + "static/media/teen_awareness-dt-en.5926f162.jpg";